import { render, staticRenderFns } from "./PurchaseHeader.vue?vue&type=template&id=34fd5ab8&scoped=true&"
import script from "./PurchaseHeader.vue?vue&type=script&lang=ts&"
export * from "./PurchaseHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseHeader.vue?vue&type=style&index=0&id=34fd5ab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fd5ab8",
  null
  
)

export default component.exports